export const initVideo = function(){
    $('.video__link').on('click',function(e){
        // replace link with iframe
        e.preventDefault();
        var parent = $(this).parent();
        var link = $(this).attr('href');
        var w = parent.width();
        var h= parent.height();
        $(this).hide();
        parent.append('<iframe class="video__iframe" width="'+w+'" height="'+h+'" src="'+link+'">');
    });
};